export default __webpack_public_path__ + "static/media/avatar_03.6ce12037.png";